<template>
    <auth-layout>
        <header-page title="Insight"/>
        <analytic/>
    </auth-layout>
</template>

<script>
import Analytic from "../components/Analytic";
export default {
    name: "Insight",
    components: {
        Analytic
    }
}
</script>

<style scoped>

</style>
